import React from "react";
const InfoCircle = ({ className = "" }) => {
    return (React.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" },
        React.createElement("g", { "clip-path": "url(#clip0_6551_9372)" },
            React.createElement("path", { d: "M7.99967 10.6668V8.00016M7.99967 5.3335H8.00634M14.6663 8.00016C14.6663 11.6821 11.6816 14.6668 7.99967 14.6668C4.31778 14.6668 1.33301 11.6821 1.33301 8.00016C1.33301 4.31826 4.31778 1.3335 7.99967 1.3335C11.6816 1.3335 14.6663 4.31826 14.6663 8.00016Z", stroke: "#72C04B", "stroke-width": "1.33333", "stroke-linecap": "round", "stroke-linejoin": "round" })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "clip0_6551_9372" },
                React.createElement("rect", { width: "16", height: "16", fill: "white" })))));
};
export default InfoCircle;
